import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { kycEndpoints } from "@/features/kyc/api/endpoints";
import type { AgentDto, AgentFilter } from "@/features/kyc/api/dto";

/**
 * Liste paginée des agents (`POST /Agents/all` — les listes sont en POST,
 * guide §4.2). Lecture authentifiée : `mutateData` en queryFn, la requête
 * reste une query TanStack (cache, invalidation).
 */
export const useAgents = (params: ListRequest<AgentFilter> = {}, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.KYC_AGENTS_LIST(params),
    queryFn: () =>
      mutateData({
        url: kycEndpoints.agents.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<AgentDto>>,
    enabled,
  });
